import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function FinalCTA() {
  return <section className="py-24 lg:py-32 bg-brand-brown relative overflow-hidden text-center" data-id="element-61">
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" data-id="element-62">
        <FlameIcon className="absolute top-10 left-10 w-32 h-32 text-brand-gold rotate-[-20deg]" data-id="element-63" />
        <FlameIcon className="absolute bottom-10 right-10 w-48 h-48 text-brand-rose rotate-[15deg]" data-id="element-64" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-65">
        <FadeIn data-id="element-66">
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-67">
            Sua jornada começa com uma decisão
          </h2>
          <p className="text-brand-cream/80 text-xl md:text-2xl mb-12 max-w-2xl mx-auto font-light leading-relaxed" data-id="element-68">
            Milhares de mulheres já transformaram suas vidas com velas
            aromáticas. A próxima pode ser você.
          </p>

          <motion.a href="#oferta" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-brand-gold text-brand-brown px-10 py-5 rounded-full font-bold text-xl shadow-xl shadow-brand-gold/20 hover:bg-white transition-colors mb-8" data-id="element-69">
            Quero Meu Ebook Agora
          </motion.a>

          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-brand-cream/60 text-sm font-medium" data-id="element-70">
            <span data-id="element-71">✓ 7 dias de garantia</span>
            <span className="hidden sm:inline" data-id="element-72">•</span>
            <span data-id="element-73">✓ Acesso imediato</span>
            <span className="hidden sm:inline" data-id="element-74">•</span>
            <span data-id="element-75">✓ Suporte exclusivo</span>
          </div>
        </FadeIn>
      </div>
    </section>;
}